import { type ModuleData, ModuleProvider, useModule } from '#providers'

interface AssetOverviewConfig {
	flowHasBankModule: boolean
	shouldInputCooperativeHomeValue: boolean
}

interface AssetOverviewData {}

export type AssetOverviewModuleData = ModuleData<
	AssetOverviewData,
	void,
	AssetOverviewConfig
>

export const AssetOverviewModuleProvider: typeof ModuleProvider<AssetOverviewModuleData> =
	ModuleProvider

export const useAssetOverviewModule: typeof useModule<AssetOverviewModuleData> =
	useModule
